module.exports = __webpack_public_path__ + "static/SignupForm-113ac53343e77b3fdcb4531e3c8f088b.png";